// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from '../menu-items';


const MenuList = () => {
    const navItems = menuItem.items.map((item) => {
        const userInfo = JSON.parse(localStorage.getItem("qbarn.user"));
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;

            case 'other':
                    if (userInfo !== null &&  userInfo['Dashboard']) {
                        return <NavGroup key={item.id} item={item} />;
                    }else{
                        return null
                    }

            case 'version':
                    if (userInfo !== null &&  userInfo['backend_version']) {
                        return (
                            <Typography variant="caption" display="block" key="version">
                                version:{process.env.REACT_APP_VERSION}-{userInfo["backend_version"]}
                            </Typography>
                        );
                    }else{
                        return null
                    }

            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
